(() => {
  class MeasurementTable extends HTMLElement {
    constructor() {
      super();
      this.currentUnit = 'cm';
      this._onGlobalUnitSwitch = this._onGlobalUnitSwitch.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onOverlayClick = this._onOverlayClick.bind(this);
    }

    connectedCallback() {
      this._cacheElements();
      this._setupEventListeners();
      this._subscribeGlobalUnitSwitch();
    }

    disconnectedCallback() {
      this._removeEventListeners();
      this._unsubscribeGlobalUnitSwitch();
    }

    _cacheElements() {
      this.unitButtons = Array.from(this.querySelectorAll('[class*="ako-unit-option"]'));
      this.popupTrigger = this.querySelector('[data-popup-trigger]');
      this.popupOverlay = this.querySelector('[data-popup-overlay]');
      this.popupClose = this.querySelector('[data-popup-close]');
      this.container = this.querySelector('.unit-table-container');
    }

    _setupEventListeners() {
      this.unitButtons.forEach(button => {
        button.addEventListener('click', this._onUnitButtonClick.bind(this));
      });

      if (this.popupTrigger) {
        this.popupTrigger.addEventListener('click', () => this.openPopup());
      }

      if (this.popupClose) {
        this.popupClose.addEventListener('click', () => this.closePopup());
      }

      if (this.popupOverlay) {
        this.popupOverlay.addEventListener('click', this._onOverlayClick);
      }

      document.addEventListener('keydown', this._onKeyDown);
    }

    _removeEventListeners() {
      this.unitButtons.forEach(button => {
        button.removeEventListener('click', this._onUnitButtonClick.bind(this));
      });

      if (this.popupTrigger) {
        this.popupTrigger.removeEventListener('click', () => this.openPopup());
      }

      if (this.popupClose) {
        this.popupClose.removeEventListener('click', () => this.closePopup());
      }

      if (this.popupOverlay) {
        this.popupOverlay.removeEventListener('click', this._onOverlayClick);
      }

      document.removeEventListener('keydown', this._onKeyDown);
    }

    _subscribeGlobalUnitSwitch() {
      document.addEventListener('globalUnitSwitch', this._onGlobalUnitSwitch);
    }

    _unsubscribeGlobalUnitSwitch() {
      document.removeEventListener('globalUnitSwitch', this._onGlobalUnitSwitch);
    }

    _onUnitButtonClick(event) {
      const unit = event.currentTarget.dataset.unit;
      if (!unit) return;
      this.handleUnitSwitch(unit);
    }

    _onGlobalUnitSwitch(event) {
      const { unit } = event.detail;
      this.handleUnitSwitch(unit, true);
    }

    _onKeyDown(event) {
      if (event.key === 'Escape') {
        this.closePopup();
      }
    }

    _onOverlayClick(event) {
      if (event.target === this.popupOverlay) {
        this.closePopup();
      }
    }

    handleUnitSwitch(unit, fromGlobal = false) {
      if (unit === this.currentUnit) return;

      this.unitButtons.forEach(button => {
        const isActive = button.dataset.unit === unit;
        button.classList.toggle('active', button.dataset.unit === unit);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      })

      if (this.container) {
        this.container.classList.remove(`${this.currentUnit}-active`);
        this.container.classList.add(`${unit}-active`);
      }

      this.currentUnit = unit;
    }

    openPopup() {
      if (!this.popupOverlay) return;
      this.popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.popupTrigger?.setAttribute('aria-expanded', 'true');
    }

    closePopup() {
      if (!this.popupOverlay) return;
      this.popupOverlay.classList.remove('active');
      document.body.style.overflow = '';
      this.popupTrigger?.setAttribute('aria-expanded', 'false');
    }
  }

  // Global unit switch buttons
  const globalUnitButtons = document.querySelectorAll('[data-global-unit]');
  globalUnitButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      const unit = event.currentTarget.dataset.globalUnit;
      if (!unit) return;

      globalUnitButtons.forEach(button => {
        const isActive = button === event.currentTarget;
        button.classList.toggle('active', button === event.currentTarget);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      // Dispatch changes to all tables on the page
      document.dispatchEvent(new CustomEvent('globalUnitSwitch', { detail: { unit } }));
    });
  });

  if (!customElements.get('measurement-table')) {
    customElements.define('measurement-table', MeasurementTable);
  }
})();
